export const queryKeys = {
  words: {
    all: ['words'],
    search: (filters) => ['words', 'search', filters],
    suggest: (q, external = false) => ['words', 'suggest', q, external ? 'external' : 'local'],
    detail: (id) => ['words', 'detail', id],
    similar: (id, params) => ['words', 'similar', id, params],
    weekPicks: (filters) => ['words', 'weekPicks', filters],
    wodHistory: (limit) => ['words', 'wodHistory', limit],
    hasAudio: (id) => ['words', 'hasAudio', id],
    audioInfo: (id) => ['words', 'audioInfo', id],
    textExamples: (id) => ['words', 'textExamples', id],
    clusters: (id) => ['words', 'clusters', id],
  },
  lessons: {
    active: () => ['lessons', 'active'],
    followUps: () => ['lessons', 'followUps'],
    detail: (id) => ['lessons', 'detail', id],
    questions: (id) => ['lessons', 'questions', id],
  },
  stats: {
    // Prefix of every summary(days) key — used to invalidate all day-windows.
    summaryAll: ['stats', 'summary'],
    summary: (days) => ['stats', 'summary', days],
    fsrs: (params) => ['stats', 'fsrs', params],
    fsrsSimulation: (params) => ['stats', 'fsrsSimulation', params],
    poolOverview: () => ['stats', 'poolOverview'],
    learningProgress: () => ['stats', 'learningProgress'],
    poolProgression: (maxDays) => ['stats', 'poolProgression', maxDays],
    poolActiveWords: () => ['stats', 'poolActiveWords'],
    cues: () => ['stats', 'cues'],
    points: () => ['stats', 'points'],
    pointsTracks: (days) => ['stats', 'points', 'tracks', days],
  },
  usage: {
    stats: (days) => ['usage', 'stats', days],
    history: (limit) => ['usage', 'history', limit],
    breakdown: (days) => ['usage', 'breakdown', days],
  },
  enums: {
    types: () => ['enums', 'types'],
  },
  languages: {
    all: ['languages'],
  },
  sidetrack: {
    labels: ['sidetrack', 'labels'],
  },
  preferences: {
    all: ['preferences'],
    dayWindow: ['preferences', 'dayWindow'],
  },
  voices: {
    all: ['voices'],
    // One key per synthesized-preview provider ('google_tts' | 'azure_tts');
    // the catalogues are per-account and must not share a cache entry.
    synth: (provider) => ['voices', 'synth', provider],
  },
  podcasts: {
    all: ['podcasts'],
    detail: (id) => ['podcasts', 'detail', id],
    transcript: (id) => ['podcasts', 'transcript', id],
  },
  synonymClusters: {
    all: ['synonymClusters'],
    list: (status) => ['synonymClusters', 'list', status],
    detail: (id) => ['synonymClusters', 'detail', id],
  },
  textImprove: {
    list: () => ['textImprove', 'list'],
    detail: (id) => ['textImprove', 'detail', id],
  },
  genus: {
    tiers: () => ['genus', 'tiers'],
    progress: (tier) => ['genus', 'progress', tier],
    stats: () => ['genus', 'stats'],
    suffixRules: () => ['genus', 'suffixRules'],
  },
  questionAudio: {
    meaningBlob: (id) => ['questionAudio', 'meaningBlob', id],
  },
  apiKeys: {
    list: () => ['apiKeys', 'list'],
    detail: (id) => ['apiKeys', 'detail', id],
    elevenlabsSubscription: (id) => ['apiKeys', 'elevenlabsSubscription', id],
  },
  oauthClients: {
    list: () => ['oauthClients', 'list'],
  },
  keyFriends: {
    // Both directions + both request inboxes come back in one payload.
    overview: () => ['keyFriends', 'overview'],
  },
  inbox: {
    all: ['inbox'],
  },
  onboarding: {
    status: () => ['onboarding', 'status'],
    preview: (answers) => ['onboarding', 'preview', answers],
    wordSuggestions: () => ['onboarding', 'wordSuggestions'],
  },
  pool: {
    status: () => ['pool', 'status'],
    nextSuggestions: () => ['pool', 'nextSuggestions'],
  },
};
